import { render, staticRenderFns } from "./EditLunchTimeSetting.vue?vue&type=template&id=572ef21d&scoped=true&"
import script from "./EditLunchTimeSetting.vue?vue&type=script&lang=js&"
export * from "./EditLunchTimeSetting.vue?vue&type=script&lang=js&"
import style0 from "./EditLunchTimeSetting.vue?vue&type=style&index=0&id=572ef21d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572ef21d",
  null
  
)

export default component.exports